// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/inventory/v1/inventory_alerts.proto" (package "c1.api.inventory.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Any } from "../../../../google/protobuf/any";
import { AppResourceRef } from "../../app/v1/app_resource";
import { AppUserRef } from "../../app/v1/app_user";
/**
 * @generated from protobuf message c1.api.inventory.v1.SearchInventoryAlertsRequest
 */
export interface SearchInventoryAlertsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated string app_ids = 3;
     */
    appIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef app_user_refs = 4;
     */
    appUserRefs: AppUserRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef identity_app_user_refs = 5;
     */
    identityAppUserRefs: AppUserRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppResourceRef app_resource_refs = 6;
     */
    appResourceRefs: AppResourceRef[];
    /**
     * @generated from protobuf field: c1.api.inventory.v1.SearchInventoryAlertsRequest.Status status = 7;
     */
    status: SearchInventoryAlertsRequest_Status;
    /**
     * @generated from protobuf field: c1.api.inventory.v1.InventoryAlertExpandMask expand_mask = 8;
     */
    expandMask?: InventoryAlertExpandMask;
}
/**
 * @generated from protobuf enum c1.api.inventory.v1.SearchInventoryAlertsRequest.Status
 */
export enum SearchInventoryAlertsRequest_Status {
    /**
     * @generated from protobuf enum value: STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: STATUS_ACTIVE = 1;
     */
    ACTIVE = 1,
    /**
     * @generated from protobuf enum value: STATUS_RESOLVED = 2;
     */
    RESOLVED = 2
}
/**
 * @generated from protobuf message c1.api.inventory.v1.SearchHistoricalInventoryAlertsRequest
 */
export interface SearchHistoricalInventoryAlertsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated string app_ids = 3;
     */
    appIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef app_user_refs = 4;
     */
    appUserRefs: AppUserRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef identity_app_user_refs = 5;
     */
    identityAppUserRefs: AppUserRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppResourceRef app_resource_refs = 6;
     */
    appResourceRefs: AppResourceRef[];
    /**
     * @generated from protobuf field: c1.api.inventory.v1.InventoryAlertExpandMask expand_mask = 7;
     */
    expandMask?: InventoryAlertExpandMask;
}
/**
 * @generated from protobuf message c1.api.inventory.v1.InventoryAlertExpandMask
 */
export interface InventoryAlertExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.inventory.v1.SearchInventoryAlertsResponse
 */
export interface SearchInventoryAlertsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.inventory.v1.InventoryAlertView list = 1;
     */
    list: InventoryAlertView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.inventory.v1.InventoryAlertView
 */
export interface InventoryAlertView {
    /**
     * @generated from protobuf field: c1.api.inventory.v1.InventoryAlert inventory_alert = 1;
     */
    inventoryAlert?: InventoryAlert;
    /**
     * @generated from protobuf field: string resource_path = 2;
     */
    resourcePath: string;
    /**
     * @generated from protobuf field: string app_path = 3;
     */
    appPath: string;
    /**
     * @generated from protobuf field: string app_resource_type_path = 4;
     */
    appResourceTypePath: string;
    /**
     * @generated from protobuf field: string app_user_path = 5;
     */
    appUserPath: string;
}
/**
 * @generated from protobuf message c1.api.inventory.v1.SearchHistoricalInventoryAlertsResponse
 */
export interface SearchHistoricalInventoryAlertsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.inventory.v1.HistoricalInventoryAlertView list = 1;
     */
    list: HistoricalInventoryAlertView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.inventory.v1.HistoricalInventoryAlertView
 */
export interface HistoricalInventoryAlertView {
    /**
     * @generated from protobuf field: c1.api.inventory.v1.HistoricalInventoryAlert historical_inventory_alert = 1;
     */
    historicalInventoryAlert?: HistoricalInventoryAlert;
    /**
     * @generated from protobuf field: string resource_path = 2;
     */
    resourcePath: string;
    /**
     * @generated from protobuf field: string app_path = 3;
     */
    appPath: string;
    /**
     * @generated from protobuf field: string app_resource_type_path = 4;
     */
    appResourceTypePath: string;
    /**
     * @generated from protobuf field: string app_user_path = 5;
     */
    appUserPath: string;
}
/**
 * @generated from protobuf message c1.api.inventory.v1.AlertMetadata
 */
export interface AlertMetadata {
    /**
     * @generated from protobuf field: string identity_app_user_id = 1;
     */
    identityAppUserId: string;
}
/**
 * @generated from protobuf message c1.api.inventory.v1.AlertData
 */
export interface AlertData {
    /**
     * @generated from protobuf field: c1.api.inventory.v1.InventoryAlertStatus status = 1;
     */
    status: InventoryAlertStatus;
    /**
     * @generated from protobuf field: c1.api.inventory.v1.InventoryAlertType type = 2;
     */
    type: InventoryAlertType;
    /**
     * @generated from protobuf field: c1.api.inventory.v1.InventoryAlertSeverity severity = 3;
     */
    severity: InventoryAlertSeverity;
    /**
     * @generated from protobuf field: c1.api.inventory.v1.AlertMetadata metadata = 4;
     */
    metadata?: AlertMetadata;
    /**
     * @generated from protobuf oneof: subject
     */
    subject: {
        oneofKind: "appResourceRef";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppResourceRef app_resource_ref = 100;
         */
        appResourceRef: AppResourceRef;
    } | {
        oneofKind: "appUserRef";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppUserRef app_user_ref = 101;
         */
        appUserRef: AppUserRef;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.inventory.v1.InventoryAlert
 */
export interface InventoryAlert {
    /**
     * @generated from protobuf field: string tenant_id = 1;
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
    /**
     * @generated from protobuf field: string scope_id = 3;
     */
    scopeId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.inventory.v1.AlertData data = 7;
     */
    data?: AlertData;
}
/**
 * @generated from protobuf message c1.api.inventory.v1.HistoricalInventoryAlert
 */
export interface HistoricalInventoryAlert {
    /**
     * @generated from protobuf field: string tenant_id = 1;
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
    /**
     * @generated from protobuf field: string scope_id = 3;
     */
    scopeId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp detected_at = 7;
     */
    detectedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.inventory.v1.AlertData data = 8;
     */
    data?: AlertData;
}
/**
 * @generated from protobuf enum c1.api.inventory.v1.InventoryAlertStatus
 */
export enum InventoryAlertStatus {
    /**
     * @generated from protobuf enum value: INVENTORY_ALERT_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: INVENTORY_ALERT_STATUS_ACTIVE = 1;
     */
    ACTIVE = 1,
    /**
     * @generated from protobuf enum value: INVENTORY_ALERT_STATUS_RESOLVED = 2;
     */
    RESOLVED = 2
}
/**
 * @generated from protobuf enum c1.api.inventory.v1.InventoryAlertType
 */
export enum InventoryAlertType {
    /**
     * @generated from protobuf enum value: INVENTORY_ALERT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * reserved
     *
     * @generated from protobuf enum value: INVENTORY_ALERT_TYPE_UNUSED_SECRET = 1;
     */
    UNUSED_SECRET = 1,
    /**
     * reserved
     *
     * @generated from protobuf enum value: INVENTORY_ALERT_TYPE_DEACTIVATED_OWNER = 2;
     */
    DEACTIVATED_OWNER = 2,
    /**
     * @generated from protobuf enum value: INVENTORY_ALERT_TYPE_UNUSED_SECRET_API_TOKEN = 3;
     */
    UNUSED_SECRET_API_TOKEN = 3,
    /**
     * @generated from protobuf enum value: INVENTORY_ALERT_TYPE_DEACTIVATED_ACCOUNT_OWNER = 4;
     */
    DEACTIVATED_ACCOUNT_OWNER = 4
}
/**
 * @generated from protobuf enum c1.api.inventory.v1.InventoryAlertSeverity
 */
export enum InventoryAlertSeverity {
    /**
     * @generated from protobuf enum value: INVENTORY_ALERT_SEVERITY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: INVENTORY_ALERT_SEVERITY_LOW = 1;
     */
    LOW = 1,
    /**
     * @generated from protobuf enum value: INVENTORY_ALERT_SEVERITY_MEDIUM = 2;
     */
    MEDIUM = 2,
    /**
     * @generated from protobuf enum value: INVENTORY_ALERT_SEVERITY_HIGH = 3;
     */
    HIGH = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class SearchInventoryAlertsRequest$Type extends MessageType<SearchInventoryAlertsRequest> {
    constructor() {
        super("c1.api.inventory.v1.SearchInventoryAlertsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 4, name: "app_user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "identity_app_user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 6, name: "app_resource_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 7, name: "status", kind: "enum", T: () => ["c1.api.inventory.v1.SearchInventoryAlertsRequest.Status", SearchInventoryAlertsRequest_Status, "STATUS_"] },
            { no: 8, name: "expand_mask", kind: "message", T: () => InventoryAlertExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.inventory.v1.SearchInventoryAlertsRequest
 */
export const SearchInventoryAlertsRequest = new SearchInventoryAlertsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchHistoricalInventoryAlertsRequest$Type extends MessageType<SearchHistoricalInventoryAlertsRequest> {
    constructor() {
        super("c1.api.inventory.v1.SearchHistoricalInventoryAlertsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 4, name: "app_user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "identity_app_user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 6, name: "app_resource_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 7, name: "expand_mask", kind: "message", T: () => InventoryAlertExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.inventory.v1.SearchHistoricalInventoryAlertsRequest
 */
export const SearchHistoricalInventoryAlertsRequest = new SearchHistoricalInventoryAlertsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InventoryAlertExpandMask$Type extends MessageType<InventoryAlertExpandMask> {
    constructor() {
        super("c1.api.inventory.v1.InventoryAlertExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_resource", "app_resource_type", "app", "app_user"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.inventory.v1.InventoryAlertExpandMask
 */
export const InventoryAlertExpandMask = new InventoryAlertExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchInventoryAlertsResponse$Type extends MessageType<SearchInventoryAlertsResponse> {
    constructor() {
        super("c1.api.inventory.v1.SearchInventoryAlertsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => InventoryAlertView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.inventory.v1.SearchInventoryAlertsResponse
 */
export const SearchInventoryAlertsResponse = new SearchInventoryAlertsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InventoryAlertView$Type extends MessageType<InventoryAlertView> {
    constructor() {
        super("c1.api.inventory.v1.InventoryAlertView", [
            { no: 1, name: "inventory_alert", kind: "message", T: () => InventoryAlert },
            { no: 2, name: "resource_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_resource_type_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.inventory.v1.InventoryAlertView
 */
export const InventoryAlertView = new InventoryAlertView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchHistoricalInventoryAlertsResponse$Type extends MessageType<SearchHistoricalInventoryAlertsResponse> {
    constructor() {
        super("c1.api.inventory.v1.SearchHistoricalInventoryAlertsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => HistoricalInventoryAlertView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.inventory.v1.SearchHistoricalInventoryAlertsResponse
 */
export const SearchHistoricalInventoryAlertsResponse = new SearchHistoricalInventoryAlertsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HistoricalInventoryAlertView$Type extends MessageType<HistoricalInventoryAlertView> {
    constructor() {
        super("c1.api.inventory.v1.HistoricalInventoryAlertView", [
            { no: 1, name: "historical_inventory_alert", kind: "message", T: () => HistoricalInventoryAlert },
            { no: 2, name: "resource_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_resource_type_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.inventory.v1.HistoricalInventoryAlertView
 */
export const HistoricalInventoryAlertView = new HistoricalInventoryAlertView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AlertMetadata$Type extends MessageType<AlertMetadata> {
    constructor() {
        super("c1.api.inventory.v1.AlertMetadata", [
            { no: 1, name: "identity_app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.inventory.v1.AlertMetadata
 */
export const AlertMetadata = new AlertMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AlertData$Type extends MessageType<AlertData> {
    constructor() {
        super("c1.api.inventory.v1.AlertData", [
            { no: 1, name: "status", kind: "enum", T: () => ["c1.api.inventory.v1.InventoryAlertStatus", InventoryAlertStatus, "INVENTORY_ALERT_STATUS_"] },
            { no: 2, name: "type", kind: "enum", T: () => ["c1.api.inventory.v1.InventoryAlertType", InventoryAlertType, "INVENTORY_ALERT_TYPE_"] },
            { no: 3, name: "severity", kind: "enum", T: () => ["c1.api.inventory.v1.InventoryAlertSeverity", InventoryAlertSeverity, "INVENTORY_ALERT_SEVERITY_"] },
            { no: 4, name: "metadata", kind: "message", T: () => AlertMetadata },
            { no: 100, name: "app_resource_ref", kind: "message", oneof: "subject", T: () => AppResourceRef },
            { no: 101, name: "app_user_ref", kind: "message", oneof: "subject", T: () => AppUserRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.inventory.v1.AlertData
 */
export const AlertData = new AlertData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InventoryAlert$Type extends MessageType<InventoryAlert> {
    constructor() {
        super("c1.api.inventory.v1.InventoryAlert", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "scope_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "data", kind: "message", T: () => AlertData, options: { "validate.rules": { message: { required: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.inventory.v1.InventoryAlert
 */
export const InventoryAlert = new InventoryAlert$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HistoricalInventoryAlert$Type extends MessageType<HistoricalInventoryAlert> {
    constructor() {
        super("c1.api.inventory.v1.HistoricalInventoryAlert", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "scope_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "detected_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "data", kind: "message", T: () => AlertData, options: { "validate.rules": { message: { required: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.inventory.v1.HistoricalInventoryAlert
 */
export const HistoricalInventoryAlert = new HistoricalInventoryAlert$Type();
/**
 * @generated ServiceType for protobuf service c1.api.inventory.v1.InventoryAlertSearch
 */
export const InventoryAlertSearch = new ServiceType("c1.api.inventory.v1.InventoryAlertSearch", [
    { name: "SearchInventoryAlerts", options: { "authz.method": { role: "VIEWER" } }, I: SearchInventoryAlertsRequest, O: SearchInventoryAlertsResponse },
    { name: "SearchHistoricalInventoryAlerts", options: { "authz.method": { role: "VIEWER" } }, I: SearchHistoricalInventoryAlertsRequest, O: SearchHistoricalInventoryAlertsResponse }
]);
